import { Injectable } from '@angular/core';

import {Md5} from "md5-typescript";

@Injectable({
  providedIn: 'root'
})
export class HashingUtil {

  constructor(
  
  ) { }

  md5( text: string ): string
  {
      return Md5.init( text )
  }

}
